module.exports = __webpack_public_path__ + "static/media/map-region.ddfab9da.svg";